export default function initScrollToTop() {
  const buttonElement = document.querySelector(".back-to-top");

  if (!buttonElement) {
    return;
  }

  document.addEventListener(
    "scroll",
    (e) => {
      buttonElement.classList.toggle('is-visible', document.scrollingElement.scrollTop > 800);
    },
    false
  );

}
